module.exports = __webpack_public_path__ + "static/media/mitra.c05a93c2.svg";